import type {
  PlatformStreamingPort,
  PlatformStreamSession,
  StartPlatformStreamParams,
} from '../ports/PlatformStreamingPort';

type StartEgressResponse = {
  egressId: string;
};

export class LiveKitEgressPlatformStreamingService implements PlatformStreamingPort {
  public async start(params: StartPlatformStreamParams): Promise<PlatformStreamSession> {
    const response = await fetch(`${params.tokenServerUrl.replace(/\/$/, '')}/egress/start`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        roomName: params.roomName,
        platforms: params.platforms,
      }),
    });

    if (!response.ok) {
      throw new Error(`Egress server returned ${response.status}: ${await response.text()}`);
    }

    const data = (await response.json()) as StartEgressResponse;

    return {
      egressId: data.egressId,
      roomName: params.roomName,
      startedAt: new Date().toISOString(),
    };
  }

  public async stop(tokenServerUrl: string, egressId: string): Promise<void> {
    const response = await fetch(`${tokenServerUrl.replace(/\/$/, '')}/egress/stop`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ egressId }),
    });

    if (!response.ok) {
      throw new Error(`Egress server returned ${response.status}: ${await response.text()}`);
    }
  }
}
